import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging';
import { EfaactDataService } from '../efaact.data-service';
import { AccrualPeriodModel } from './accrual-period.model';

export const entityName = 'AccrueLeavePeriod';
@Injectable({ providedIn: 'root' })
export class AccrualPeriodDataService extends EfaactDataService<AccrualPeriodModel> {
    mapItems(item: AccrualPeriodModel): AccrualPeriodModel {
        return {
            ...item,
            id: item.AccrueLeavePeriodID
        };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
